import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Logger, ConfigManager, ModuleTypeEnum, PluginManager } from '@kailona/core';
import { ThemeProvider, Loader } from '@kailona/ui';
import { ModalProvider } from './context/ModalContext';
import { NotificationProvider } from './context/NotificationContext';
import { MainContextProvider } from './context/MainContext';
import Dashboard from './components/Dashboard';
import MainLayout from './components/MainLayout';
import initFHIRPatients from './lib/initFHIRPatients';
import importLocalFonts from './lib/importLocalFonts';
import './App.css';
var logger = new Logger('main.App');

var App = /*#__PURE__*/function (_Component) {
  _inherits(App, _Component);

  var _super = _createSuper(App);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var firstTime;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Load local fonts
              importLocalFonts(ConfigManager.appConfig.fontsPath);
              _context.prev = 1;
              _context.next = 4;
              return initFHIRPatients();

            case 4:
              firstTime = _context.sent;
              // Register available plugins
              ConfigManager.appConfig.plugins.forEach(function (plugin) {
                PluginManager.registerPlugin(plugin);
              });

              _this.setState({
                loading: false,
                firstTime: firstTime
              });

              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              logger.error('Failed to initialize', _context.t0);

              _this.setState({
                loading: false,
                error: t('ehr', 'Failed to initialize! Please contact your administrator!')
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "getPluginRoutes", function () {
      var routes = [];
      PluginManager.plugins.forEach(function (plugin, index) {
        var path = plugin.path,
            modules = plugin.modules;
        var DataModule = modules[ModuleTypeEnum.DataModule].Component;
        routes.push( /*#__PURE__*/React.createElement(Route, {
          key: index,
          path: path,
          render: function render() {
            return /*#__PURE__*/React.createElement(MainLayout, {
              error: _this.state.error
            }, /*#__PURE__*/React.createElement(DataModule, null));
          }
        }));
      });
      return routes;
    });

    _this.basename = ConfigManager.appConfig.basename;
    _this.state = {
      loading: true,
      error: null
    };
    return _this;
  }

  _createClass(App, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var pluginRoutes = this.getPluginRoutes();
      return /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(MainContextProvider, null, /*#__PURE__*/React.createElement(NotificationProvider, null, /*#__PURE__*/React.createElement(ModalProvider, null, this.state.loading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Router, {
        basename: this.basename
      }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/",
        render: function render() {
          return /*#__PURE__*/React.createElement(MainLayout, {
            firstTime: _this2.state.firstTime,
            error: _this2.state.error
          }, /*#__PURE__*/React.createElement(Dashboard, null));
        }
      }), pluginRoutes))))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return App;
}(Component);

export { App as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/App.js");
  reactHotLoader.register(App, "App", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/App.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();